export const REMINDER_SHILL_FEATURE_FLAG = "mem-agent-note-shills";

/**
 * Treats unknown reminder-shill flag state as disabled so server-side targeting
 * remains the only way to expose generated reminder suggestions.
 */
export function isReminderShillFeatureFlagEnabled({
  getFlagStatus,
}: {
  getFlagStatus: (flag: string) => boolean | undefined;
}): boolean {
  return getFlagStatus(REMINDER_SHILL_FEATURE_FLAG) === true;
}
